
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import globalThis_1 from './global-this.js';
import isCallable$1 from './is-callable.js';

var globalThis = globalThis_1;
var isCallable = isCallable$1;

var WeakMap = globalThis.WeakMap;

var weakMapBasicDetection = isCallable(WeakMap) && /native code/.test(String(WeakMap));

export { weakMapBasicDetection as default };
//# sourceMappingURL=weak-map-basic-detection.js.map
